import React from 'react';
import {createRoot} from 'react-dom/client';
import App from '../App';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Build timestamp - updates on each build/restart
const BUILD_TIMESTAMP = Date.now();
const BUILD_TIME = new Date(BUILD_TIMESTAMP).toLocaleString('he-IL', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit'
});

// Store build info in window for debugging
window.__CALPRO_BUILD__ = {
  timestamp: BUILD_TIMESTAMP,
  time: BUILD_TIME,
  version: '1.0.0',
  environment: process.env.NODE_ENV || 'development'
};

// Log build info to console
console.log('%c🚀 CalPro App Loaded', 'color: #FF69B4; font-size: 16px; font-weight: bold;');
console.log('📅 Build Time:', BUILD_TIME);
console.log('🔢 Version:', window.__CALPRO_BUILD__.version);
console.log('🌐 Environment:', window.__CALPRO_BUILD__.environment);
console.log('⏰ Timestamp:', BUILD_TIMESTAMP);
console.log('💡 To check build info: window.__CALPRO_BUILD__');

// Service worker:
// - In production: register for PWA/offline.
// - In development: UNREGISTER to prevent aggressive caching on phones (causes stale JS + weird bugs).
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    if (process.env.NODE_ENV === 'production') {
      try {
        const registration = await navigator.serviceWorker.register('/service-worker.js');
        console.log('[Service Worker] Registered successfully:', registration);
      } catch (registrationError) {
        console.warn('[Service Worker] Registration failed:', registrationError);
      }
      return;
    }

    // Development: ensure no SW is controlling the page.
    try {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map(r => r.unregister()));
      if (regs.length > 0) {
        console.log('[Service Worker] Unregistered existing registrations in development');
      }
    } catch (e) {
      // Ignore
    }
  });
}

